// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'home';

export const Component = () => (
  <path d='M24.359 12.616 12.828 2.14A.426.426 0 0 0 12.5 2a.426.426 0 0 0-.328.14L.64 12.616a.525.525 0 0 0-.141.372c0 .326.14.466.469.466.14 0 .234-.046.328-.14l2.062-1.862v10.104c0 .42.14.745.422 1.025.281.28.61.419 1.032.419h15.374c.422 0 .75-.14 1.032-.42.281-.279.422-.605.422-1.024V11.452l2.062 1.909c.14.046.234.093.328.093.328 0 .469-.14.469-.466 0-.14-.047-.28-.14-.372h-.001Zm-3.656-2.002h-.047v10.942c0 .326-.14.512-.469.512H4.813c-.328 0-.47-.186-.47-.512V10.614h-.046l8.203-7.45 8.204 7.45h-.001Z' />
);

export const viewBox = '0 0 25 25';
